import {
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {RouteProp, useNavigation, useRoute} from '@react-navigation/core';
import {useFocusEffect} from '@react-navigation/native';
import {useDispatch, useSelector} from 'Provider';
import {useCallback} from 'react';
import React from 'react';

import {ModalWrapper} from 'components/ModalWrapper';
import TransferRewardCredits from 'components/TransferRewardsCredits';
import {usePageViewEvent} from 'hooks/usePageViewEvent';
import {Routes} from 'models/Navigation';
import {ExchangeTransactionType} from 'services/api/affiliate';
import {AffiliateActions} from 'store/affiliate/affiliate.reducer';
import {
  affiliateAccountListMapSelector,
  initiateExchangeCurrencyErrorSelector,
  initiateExchangeCurrencyStateSelector,
} from 'store/affiliate/affiliate.selectors';

type ParamList = {TransferCredits: {partnerId: string | undefined}};

const TransferCreditsScreen = () => {
  const dispatch = useDispatch();
  const route = useRoute<RouteProp<ParamList, 'TransferCredits'>>();
  const partnerId = route?.params?.partnerId || '';
  const affiliateAccountListMap = useSelector(affiliateAccountListMapSelector);
  const account = affiliateAccountListMap?.[partnerId];
  const rewards = useWidgetState(Selectors.userRewardCreditSelector) as number;
  const {navigate} = useNavigation();
  const exchangeCallState = useSelector(initiateExchangeCurrencyStateSelector);
  const apiErrorMsg = useSelector(initiateExchangeCurrencyErrorSelector);

  const {trackPageViewEvent} = usePageViewEvent();

  useFocusEffect(trackPageViewEvent);

  const onTransferPress = useCallback(
    ({amount, type}: {amount: string; type: ExchangeTransactionType}) => {
      dispatch(
        AffiliateActions.initiateExchangeCurrency({
          partnerid: partnerId,
          partneraccountid: account?.accountId || '',
          transactiontype: type,
          creditstotransfer: amount,
        })
      );
    },
    [account?.accountId, dispatch, partnerId]
  );

  return (
    <ModalWrapper onClosePress={() => navigate(Routes.Main.Home)}>
      <TransferRewardCredits
        onTransferPress={onTransferPress}
        mainBalance={rewards}
        localBalance={account?.rewardCreditBalance || 0}
        conversionRate={account?.rewardCreditsToCurrencyConversionRate || 1}
        apiState={exchangeCallState}
        apiErrorMsg={apiErrorMsg}
      />
    </ModalWrapper>
  );
};

export default TransferCreditsScreen;
